import React, { Suspense, lazy, useEffect } from "react";
import { Router, Switch, Route } from "react-router-dom";

import { history } from "./history";
import { connect } from "react-redux";
import Spinner from "./components/@vuexy/spinner/Loading-spinner";
import { ContextLayout } from "./utility/context/Layout";
import { getData } from "./api/controller/Controller";
import withAccessControl from "./utility/accessControl";
import { UserData } from "./hooks/context/user/userContext";

// Route-based code splitting
const Manage = lazy(() => import("./views/pages/Home"));
const ManageMenu = lazy(() => import("./views/pages/manage/menu/Menu"));
const CreateMenu = lazy(() => import("./views/pages/manage/menu/Create"));
const UpdateMenu = lazy(() => import("./views/pages/manage/menu/Update"));
const AccessRole = lazy(() => import("./views/pages/manage/role/Access"));
const ManageRole = lazy(() => import("./views/pages/manage/role/Role"));
const CreateRole = lazy(() => import("./views/pages/manage/role/Create"));
const UpdateRole = lazy(() => import("./views/pages/manage/role/Update"));
const PageUnderConstruction = lazy(() =>
  import("./components/pageUnderConstruction/pageUnderConstruction")
);
const PageUnauthorized = lazy(() =>
  import("./components/pageUnauthorized/pageUnauthorized")
);

// Dashboard
const Dashboard = lazy(() => import("./views/pages/dashboard/index"));

//  User
const User = lazy(() => import("./views/pages/user/User"));
const CreateUser = lazy(() => import("./views/pages/user/Create"));
const UpdateUser = lazy(() => import("./views/pages/user/Update"));

// Customer
const Customer = lazy(() => import("./views/pages/customer/Customer"));
const CreateCustomer = lazy(() => import("./views/pages/customer/Create"));
const UpdateCustomer = lazy(() => import("./views/pages/customer/Update"));
const DetailCustomer = lazy(() => import("./views/pages/customer/Detail"));

// Currency
const Currency = lazy(() => import("./views/pages/currency/Currency"));
const CreateCurrency = lazy(() => import("./views/pages/currency/Create"));
const UpdateCurrency = lazy(() => import("./views/pages/currency/Update"));
const DetailCurrency = lazy(() => import("./views/pages/currency/Detail"));

// Customer
const DetailHotel = lazy(() => import("./views/pages/project/DetailHotel"));
const DetailFlight = lazy(() => import("./views/pages/project/DetailFlight"));
const Project2 = lazy(() => import("./views/pages/project/Project2"));
const Project3 = lazy(() => import("./views/pages/project/Project3"));

// Invoice
const Invoice = lazy(() => import("./views/pages/invoice/Invoice"));
const InvoiceProceed = lazy(() =>
  import("./views/pages/invoice/proceed/index")
);
// const CreateInvoice = lazy(() => import("./views/pages/invoice/create/index"));
// const UpdateInvoice = lazy(() => import("./views/pages/invoice/update/index"));
// const DetailInvoice = lazy(() => import("./views/pages/invoice/detail/index"));

// GDS Flight
const GDSFlight = lazy(() =>
  import("./views/pages/newBooking/gdsFlight/GDSFlight")
);

// Non GDS Flight
const nonGDSFlight = lazy(() =>
  import("./views/pages/newBooking/nonGdsFlight/nonGDSFlight")
);

// Hotel
const Hotel = lazy(() => import("./views/pages/newBooking/hotel/Hotel"));

// Sales Target
const SalesTarget = lazy(() => import("./views/pages/salesTarget/SalesTarget"));

// Sales Report
const SalesReport = lazy(() => import("./views/pages/salesReport/SalesReport"));

// Booking Order
// const BookingProceed = lazy(() =>
//   import("./views/pages/salesOrder/booking/proceed/index")
// );

// Sales Order
const Booking = lazy(() => import("./views/pages/salesOrder/booking/index"));
const SalesOrder = lazy(() => import("./views/pages/salesOrder/SalesOrder"));
const SalesOrderProceed = lazy(() =>
  import("./views/pages/salesOrder/Proceed/index")
);
// const CreateSalesOrder = lazy(() =>
//   import("./views/pages/salesOrder/create/index")
// );
// const UpdateSalesOrder = lazy(() =>
//   import("./views/pages/salesOrder/update/index")
// );
// const DetailSalesOrder = lazy(() =>
//   import("./views/pages/salesOrder/detail/index")
// );

// Vendor
const Vendor = lazy(() => import("./views/pages/vendor/index"));
const VendorProceed = lazy(() => import("./views/pages/vendor/proceed/index"));
const VendorType = lazy(() => import("./views/pages/vendor/type/index"));

// const login = lazy(() => import("./views/pages/authentication/login/Login"));
const Login = lazy(() => import("./views/Auth/Login"));

// Set Layout and Component Using App Route
const RouteConfig = ({ component: Component, fullLayout, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      return (
        <ContextLayout.Consumer>
          {(context) => {
            let LayoutTag =
              fullLayout === true
                ? context.fullLayout
                : context.state.activeLayout === "horizontal"
                ? context.horizontalLayout
                : context.VerticalLayout;
            return (
              <LayoutTag {...props} permission={props.user}>
                <Suspense fallback={<Spinner />}>
                  <Component {...props} />
                </Suspense>
              </LayoutTag>
            );
          }}
        </ContextLayout.Consumer>
      );
    }}
  />
);
const mapStateToProps = (state) => {
  return {
    user: state.auth.login.userRole,
  };
};

const AppRoute = connect(mapStateToProps)(RouteConfig);

function AppRouter() {
  const { state } = UserData();

  const cekAuth = async () => {
    const res = await getData(null, "me");
    if (state.token) {
      if (res.status === 401) {
        history.push("/");
      }
    }
  };

  useEffect(() => {
    cekAuth();
    // eslint-disable-next-line
  }, []);

  return (
    // Set the directory path if you are deploying in sub-folder
    <Router history={history}>
      {/* <Route path="/" component={Login} /> */}
      <Switch>
        <AppRoute exact path="/" component={Login} fullLayout />
        <AppRoute path="/dashboard" component={Dashboard} />

        <AppRoute path="/manage" component={Manage} />
        <AppRoute
          path="/manage-menu"
          component={withAccessControl(ManageMenu, "/manage-menu")}
        />
        <AppRoute
          path="/create-menu"
          component={withAccessControl(CreateMenu, "/manage-menu")}
        />
        <AppRoute
          path="/update-menu/:id"
          component={withAccessControl(UpdateMenu, "/manage-menu")}
        />
        <AppRoute
          path="/manage-role"
          component={withAccessControl(ManageRole, "/manage-role")}
        />
        <AppRoute
          path="/create-role"
          component={withAccessControl(CreateRole, "/manage-role")}
        />
        <AppRoute
          path="/update-role/:id"
          component={withAccessControl(UpdateRole, "/manage-role")}
        />
        <AppRoute
          path="/access-role/:id"
          component={withAccessControl(AccessRole, "/manage-role")}
        />
        <AppRoute path="/user" component={withAccessControl(User, "/user")} />
        <AppRoute
          path="/create-user"
          component={withAccessControl(CreateUser, "/user")}
        />
        <AppRoute
          path="/update-user/:id"
          component={withAccessControl(UpdateUser, "/user")}
        />
        <AppRoute
          path="/customer"
          component={withAccessControl(Customer, "/customer")}
        />
        <AppRoute
          path="/create-customer"
          component={withAccessControl(CreateCustomer, "/customer")}
        />
        <AppRoute
          path="/update-customer/:id"
          component={withAccessControl(UpdateCustomer, "/customer")}
        />
        <AppRoute
          path="/detail-customer/:id"
          component={withAccessControl(DetailCustomer, "/customer")}
        />
        <AppRoute path="/detail-hotel" component={DetailHotel} />
        <AppRoute path="/detail-flight" component={DetailFlight} />
        <AppRoute path="/project-2" component={Project2} />
        <AppRoute path="/project-3" component={Project3} />
        <AppRoute
          path="/currency"
          component={withAccessControl(Currency, "/currency")}
        />
        <AppRoute
          path="/create-currency"
          component={withAccessControl(CreateCurrency, "/currency")}
        />
        <AppRoute
          path="/update-currency/:id"
          component={withAccessControl(UpdateCurrency, "/currency")}
        />
        <AppRoute
          path="/detail-currency"
          component={withAccessControl(DetailCurrency, "/currency")}
        />
        <AppRoute path="/gds" component={GDSFlight} />
        <AppRoute path="/non-gds" component={nonGDSFlight} />
        <AppRoute path="/hotel" component={Hotel} />
        <AppRoute path="/insurance-booking" component={PageUnderConstruction} />
        <AppRoute path="/package-booking" component={PageUnderConstruction} />
        <AppRoute path="/airline-booking" component={PageUnderConstruction} />
        <AppRoute path="/hotel-booking" component={PageUnderConstruction} />
        <AppRoute path="/train-booking" component={PageUnderConstruction} />
        <AppRoute
          path="/sales-target"
          component={withAccessControl(SalesTarget, "/sales-target")}
        />

        {/* Booking Code */}
        <AppRoute
          path="/booking"
          component={withAccessControl(Booking, "/booking")}
        />
        <AppRoute
          path="/:mode-booking"
          component={withAccessControl(SalesOrderProceed, "/booking")}
        />

        {/* Sales Order */}
        <AppRoute
          path="/sales-order"
          component={withAccessControl(SalesOrder, "/sales-order")}
        />
        <AppRoute
          path="/:mode-sales-order"
          component={withAccessControl(SalesOrderProceed, "/sales-order")}
        />
        {/* <AppRoute
          path="/create-sales-order"
          component={withAccessControl(CreateSalesOrder, "/sales-order")}
        />
        <AppRoute
          path="/update-sales-order"
          component={withAccessControl(UpdateSalesOrder, "/sales-order")}
        />
        <AppRoute
          path="/detail-sales-order"
          component={withAccessControl(DetailSalesOrder, "/sales-order")}
        /> */}
        <AppRoute path="/sales-project" component={PageUnderConstruction} />

        {/* Invoice */}
        <AppRoute
          path="/sales-invoice"
          component={withAccessControl(Invoice, "/sales-invoice")}
        />
        <AppRoute
          path="/:mode-invoice"
          component={withAccessControl(InvoiceProceed, "/sales-invoice")}
        />

        {/* Vendor */}
        <AppRoute
          path="/vendor"
          component={withAccessControl(Vendor, "/vendor")}
        />
        <AppRoute
          path="/:mode-vendor"
          component={withAccessControl(VendorProceed, "/vendor")}
        />
        <AppRoute
          path="/vendor-type"
          component={withAccessControl(VendorType, "/vendor-type")}
        />

        {/* <AppRoute
          path="/create-invoice"
          component={withAccessControl(CreateInvoice, "/sales-invoice")}
        />
        <AppRoute
          path="/update-invoice/:id"
          component={withAccessControl(UpdateInvoice, "/sales-invoice")}
        />
        <AppRoute
          path="/detail-invoice/:id"
          component={withAccessControl(DetailInvoice, "/sales-invoice")}
        /> */}
        <AppRoute
          path="/sales-report"
          component={withAccessControl(SalesReport, "/sales-report")}
        />
        <AppRoute
          path="/sales-order-report"
          component={PageUnderConstruction}
        />
        <AppRoute path="/general-profile" component={PageUnderConstruction} />
        <AppRoute path="/unauthorized" component={PageUnauthorized} />
        <AppRoute path="*" component={PageUnderConstruction} />
      </Switch>
    </Router>
  );
}

export default AppRouter;
